export default {
  "b2b.provozni-informace.page-heading.new": "Nová provozní informace",
  "b2b.provozni-informace.page-heading.edit": "Editace provozní informace"
};
